import React from 'react';

// Creating the context object and passing the default values.
const feedbackContext = React.createContext();

export default feedbackContext;
